import { Lock, ShieldCheck, Unlock } from "lucide-react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DecryptForm } from "@/components/crypto/DecryptForm";
import { EncryptForm } from "@/components/crypto/EncryptForm";

export function HomePage() {
  return (
    <main className="mx-auto flex min-h-full w-full max-w-2xl flex-col gap-8 px-4 py-10 md:py-16">
      <header className="space-y-3 text-center">
        <div className="flex items-center justify-center gap-2">
          <ShieldCheck className="h-7 w-7 text-primary" />
          <h1 className="text-3xl font-bold tracking-tight">
            AES Encryption Toolkit
          </h1>
        </div>
        <p className="mx-auto max-w-md text-sm text-muted-foreground">
          Encrypt and decrypt text with AES-CBC. Everything runs locally in your
          browser via the Web Crypto API — no key or data ever leaves this page.
        </p>
      </header>

      <Tabs defaultValue="encrypt" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="encrypt">
            <Lock className="mr-2 h-4 w-4" />
            Encrypt
          </TabsTrigger>
          <TabsTrigger value="decrypt">
            <Unlock className="mr-2 h-4 w-4" />
            Decrypt
          </TabsTrigger>
        </TabsList>
        <TabsContent value="encrypt">
          <EncryptForm />
        </TabsContent>
        <TabsContent value="decrypt">
          <DecryptForm />
        </TabsContent>
      </Tabs>

      <footer className="text-center text-xs text-muted-foreground">
        AES-CBC · 128 / 192 / 256-bit · PKCS#7 padding
      </footer>
    </main>
  );
}
